const validation = {
  this_field_is_required: 'This field is required',
  please_enter_a_valid_email_address: 'Please enter a valid email address',
  this_is_an_invalid_password: 'This is an invalid password',
  please_select_one_option: 'Please select one option',
  start_time_is_greater_than_end_time: 'Start time is greater than end time',
  invalid_url: 'Invalid url',
  please_fill_this_field: 'Please fill this field',
};

export default validation;
